module.exports = __webpack_public_path__ + "img/homepage-quick-links-cjdr.9dd0b7b5.jpg";